import * as React from "react";
import { Spinner, SpinnerSize, Tab, Tabs } from "@blueprintjs/core";
import { useCommonHooks, useEditRouteParams } from "../../../hooks";
import { useQuery } from "react-query";
import { ERoutes } from "../../../AppRouter";
import { BackButton, PageBase } from "../../../components";
import FormQuestionOperationalDetailPanel from "./FormQuestionOperationalDetailPanel";

export interface FormQuestionOperationalItemPageProps {}

export const FormQuestionOperationalItemPage: React.FunctionComponent<
  FormQuestionOperationalItemPageProps
> = () => {
  const { t, router, apis } = useCommonHooks();
  const { id, tab } = useEditRouteParams();

  const { data: displayName, isFetching: loadingDisplayName } = useQuery(
    ["form-question-operational-display-name", id],
    async () => {
      if (+id > 0) {
        return await apis.formQuestionOperationals.getDisplayName(+id);
      }
      return t("NewFormQuestionOperational");
    }
  );

  const breadCrumbs = React.useMemo(() => {
    return [
      {
        text: t("FormQuestionOperationals"),
        route: ERoutes.formQuestionOperationals,
      },
      {
        text: loadingDisplayName ? (
          <Spinner size={SpinnerSize.SMALL} />
        ) : (
          displayName.text
        ),
      },
    ];
  }, [displayName, loadingDisplayName, t]);

  return (
    <PageBase breadCrumbs={breadCrumbs}>
      <Tabs
        selectedTabId={tab}
        onChange={(nextTabId) =>
          router.push(`${ERoutes.formQuestionOperationals}/${id}/${nextTabId}`)
        }
      >
        <BackButton backRoute={ERoutes.formQuestionOperationals} />
        <Tab
          id="details"
          title={t("Details")}
          panel={
            <FormQuestionOperationalDetailPanel
              formQuestionOperationalId={+id}
            />
          }
        />
      </Tabs>
    </PageBase>
  );
};

export default FormQuestionOperationalItemPage;
